import { createApp } from "vue";
import { createGtm } from "@gtm-support/vue-gtm";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VueScrollTo from "vue-scrollto";
import "./registerServiceWorker";

import AOS from "aos";
import "aos/dist/aos.css";

import "./assets/styles/tailwind.scss";
import "./assets/styles/global.scss";

import { createI18n } from "vue-i18n";

import lazySizes from "lazysizes";
import "lazysizes/plugins/attrchange/ls.attrchange";

AOS.init({
  duration: 700,
  offset: -200,
  easing: "ease-in-out-sine",
});

export const DEFAULT_LOCALE = "pl";
export const AVAILABLE_LOCALES = [
  {
    flag: "🇵🇱",
    shortName: "pl",
    name: "Polski",
  },
  {
    flag: "🇩🇪",
    shortName: "de",
    name: "Deutsch",
  },
  {
    flag: "🇬🇧",
    shortName: "en",
    name: "English",
  },
];

const navigatorLocale = navigator.language.split("-")[0];
export const chosenLocale = AVAILABLE_LOCALES.map(
  (locale) => locale.shortName
).includes(navigatorLocale)
  ? navigatorLocale
  : DEFAULT_LOCALE;

const i18n = createI18n({
  legacy: false,
  locale: chosenLocale,
  fallbackLocale: DEFAULT_LOCALE,
});

createApp(App)
  .use(store)
  .use(router)
  .use(i18n)
  .use(VueScrollTo, {
    easing: [0.86, 0, 0.07, 1],
    duration: 1500,
  })
  .use(
    createGtm({
      id: "GTM-KXL37S5", // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
      // queryParams: {
      //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
      //   gtm_auth: "AB7cDEf3GHIjkl-MnOP8qr",
      //   gtm_preview: "env-4",
      //   gtm_cookies_win: "x",
      // },
      defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
      compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
      nonce: "2726c7f26c", // Will add `nonce` to the script tag
      enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
      debug: false, // Whether or not display console logs debugs (optional)
      loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
      vueRouter: router, // Pass the router instance to automatically sync with router (optional)
      // ignoredViews: ["homepage"], // Don't trigger events for specified router names (optional)
      trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
    })
  )
  .mount("#app");
